async function HasEductor(designid) {

    if (
        designid.length > 0
    ) {

        let response;

        let params = {
            "@DesignId": designid
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "82",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default HasEductor;